// extracted by mini-css-extract-plugin
module.exports = {"component":"generic-product_component__MUNK5"};